import type {
  CatalogRefreshDiff,
  NewProduct,
  RemovedProduct,
  UnchangedProduct,
  MsrpChange,
} from "../types/catalog-refresh";

const lgNewProducts: NewProduct[] = [
  {
    id: "new-1",
    name: "LG G5 OLED evo 4K Smart TV",
    oemCategory: "OLED TVs",
    variants: [
      { label: '55"', oemPrice: 2499 },
      { label: '65"', oemPrice: 3299 },
      { label: '77"', oemPrice: 4499 },
    ],
    oemPriceRange: { min: 2499, max: 4499 },
    matchStatus: "no_match",
    matchedProductLineId: null,
    matchedProductLineName: null,
    reviewStatus: null,
  },
  {
    id: "new-2",
    name: "LG B5 OLED 4K Smart TV",
    oemCategory: "OLED TVs",
    variants: [
      { label: '55"', oemPrice: 1299 },
      { label: '65"', oemPrice: 1799 },
    ],
    oemPriceRange: { min: 1299, max: 1799 },
    matchStatus: "possible_duplicate",
    matchedProductLineId: "pl-lg-b4",
    matchedProductLineName: "LG B4 OLED",
    reviewStatus: null,
  },
  {
    id: "new-3",
    name: "LG QNED90T Mini-LED 4K Smart TV",
    oemCategory: "Mini-LED TVs",
    variants: [
      { label: '65"', oemPrice: 1599 },
      { label: '75"', oemPrice: 2099 },
      { label: '86"', oemPrice: 2799 },
    ],
    oemPriceRange: { min: 1599, max: 2799 },
    matchStatus: "no_match",
    matchedProductLineId: null,
    matchedProductLineName: null,
    reviewStatus: null,
  },
];

const lgRemovedProducts: RemovedProduct[] = [
  {
    id: "rem-1",
    productLineId: "pl-lg-a2",
    name: "LG A2 OLED 4K Smart TV (2024)",
    lastSeenAt: "2026-02-15T00:00:00Z",
    consecutiveMisses: 3,
    stillAtRetailers: [
      { retailerId: "r1", retailerName: "Best Buy", domain: "bestbuy.com", hasListing: true },
      { retailerId: "r2", retailerName: "Amazon", domain: "amazon.com", hasListing: true },
      { retailerId: "r3", retailerName: "Walmart", domain: "walmart.com", hasListing: false },
      { retailerId: "r4", retailerName: "Target", domain: "target.com", hasListing: false },
      { retailerId: "r5", retailerName: "Costco", domain: "costco.com", hasListing: false },
    ],
    reviewStatus: null,
  },
];

const lgUnchangedProducts: UnchangedProduct[] = [
  { id: "unch-1", productLineId: "pl-lg-c4", name: "LG C4 OLED evo 4K Smart TV", variantCount: 4 },
  { id: "unch-2", productLineId: "pl-lg-g4", name: "LG G4 OLED evo 4K Smart TV", variantCount: 4 },
  { id: "unch-3", productLineId: "pl-lg-m4", name: "LG M4 OLED evo 4K Smart TV", variantCount: 3 },
  { id: "unch-4", productLineId: "pl-lg-qn90", name: "LG QNED90 Mini-LED 4K Smart TV", variantCount: 3 },
  { id: "unch-5", productLineId: "pl-lg-qn85", name: "LG QNED85 Mini-LED 4K Smart TV", variantCount: 3 },
  { id: "unch-6", productLineId: "pl-lg-ut80", name: "LG UT8000 LED 4K Smart TV", variantCount: 5 },
];

const lgMsrpChanges: MsrpChange[] = [
  {
    id: "msrp-1",
    productLineId: "pl-lg-c4",
    name: 'LG C4 OLED evo 65"',
    previousMsrp: 2099,
    newMsrp: 1899,
    delta: -200,
    percentChange: -9.5,
    reviewStatus: null,
  },
  {
    id: "msrp-2",
    productLineId: "pl-lg-g4",
    name: 'LG G4 OLED evo 77"',
    previousMsrp: 3999,
    newMsrp: 4299,
    delta: 300,
    percentChange: 7.5,
    reviewStatus: null,
  },
];

export const MOCK_CATALOG_REFRESH_DIFFS: Record<string, CatalogRefreshDiff> = {
  b2: {
    id: "refresh-lg-1",
    brandId: "b2",
    brandName: "LG",
    refreshedAt: "2026-03-19T08:30:00Z",
    durationSeconds: 42,
    adapterHealth: "degraded",
    summary: {
      newCount: lgNewProducts.length,
      removedCount: lgRemovedProducts.length,
      unchangedCount: lgUnchangedProducts.length,
      msrpChangedCount: lgMsrpChanges.length,
    },
    newProducts: lgNewProducts,
    removedProducts: lgRemovedProducts,
    unchangedProducts: lgUnchangedProducts,
    msrpChanges: lgMsrpChanges,
  },
};
